/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { Provider } from "react-redux";
import { StylesProvider, ThemeProvider } from "@material-ui/core/styles";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ViaDesignSystemProvider } from "via-react-design-system";

import ApplicationErrorFallback from "application/components/ApplicationErrorFallback";
import theme from "common/styles/CommonTheme";
import { createModuleStore } from "store";
import { logAnalyticsEvent } from "common/analytics";
import AnalyticsEventName from "common/analytics/types/AnalyticsEventName";
import LoadingComponent from "application/ApplicationInit";

export default function ApplicationProvider() {
    if (/shiftplan/.test(window.location.host)) {
        const viacalUrl = window.location.href.replace("shiftplan", "viacal");
        window.location.replace(viacalUrl);
    }

    const store = createModuleStore();

    const reportApplicationError = (error: Error, info: { componentStack: string }) => {
        setTimeout(() => {
            logAnalyticsEvent({
                name: AnalyticsEventName.ApplicationError,
                info: {
                    error: {
                        message: error.message,
                        name: error.name,
                        stack: error.stack,
                    },
                    stack: info.componentStack,
                },
            });
        }, 500);
    };

    return (
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <StylesProvider>
                        <ViaDesignSystemProvider>
                            <ErrorBoundary
                                FallbackComponent={ApplicationErrorFallback}
                                onReset={window.location.reload}
                                onError={reportApplicationError}
                            >
                                <LoadingComponent />
                            </ErrorBoundary>
                        </ViaDesignSystemProvider>
                    </StylesProvider>
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    );
}
